import { RootDiv, InfoIcon, InfoText } from '../styles/AddMethodMessage.styles';

export function AddMethodMessage() {
  return (
    <RootDiv>
      <InfoIcon />
      <InfoText>
        Se cobrará un monto de $50 para registrar la tarjeta. Este será devuelto
        de forma automática.
      </InfoText>
    </RootDiv>
  );
}
